export { ShipperFeatureShipmentModule } from './lib/shipper-feature-shipment.module';
export { ROUTE_SHIPMENT_SEARCH } from './lib/shared/routes';
export {
  SHIPMENT_STATUS_DRAFT,
  SHIPMENT_STATUS_UNSECURED,
  SHIPMENT_STATUS_DRIVER_CONFIRMATION_PENDING,
  SHIPMENT_STATUS_BOOKED,
  SHIPMENT_STATUS_BILL_OF_LADING_AVAILABLE,
  SHIPMENT_STATUS_OUT_FOR_DELIVERY,
  SHIPMENT_STATUS_DELIVERED,
  SHIPMENT_STATUS_COMPLETED,
  SHIPMENT_STATUS_INACTIVE,
  SHIPMENT_STATUS_CANCELLED
} from './lib/shared/shipment-status';
